module.exports = __webpack_public_path__ + "2cf9ce47189b2beb3426ffa38391096d.svg";